import { Outlet } from 'react-router-dom'
import { NotificationList } from '@/components/ui/NotificationList'

export function POSLayout() {
  return (
    <div className="min-h-screen bg-bg-base text-text-primary overflow-hidden">
      <Outlet />
      <NotificationList />
    </div>
  )
}
